import { fieldMixin } from '@/mixins';

export default {
	name: 'cs-field-textarea',
	mixins: [fieldMixin],
};
